import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { withTranslation } from 'react-i18next';
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import { withStyles } from '@material-ui/core/styles';
import ErrorIcon from '@material-ui/icons/Error';
import Typography from '@material-ui/core/Typography';

const styles = {
  dialogbox: {
    position: 'fixed',
    top: '20%'
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '20px',
    marginBottom: '20px'
  },
  errorIcon: {
    fontSize: '96px',
    color: '#f44336',
    marginBottom: '10px'
  },
  errorMessage: {
    color: '#f44336',
    textAlign: 'center'
  }
};

class ConfirmPaymentDialog extends React.Component {
  render() {
    const { classes, t, paymentStatus } = this.props;
    return (
      <Dialog
        className={classes.dialogbox}
        open={this.props.open}
        onClose={this.props.handleCloseDialog}
        scroll="body"
      >
        <DialogTitle>{paymentStatus === 'failed' ? t('paymentFailed') : t('confirmPayment')}</DialogTitle>
        <DialogContent>
          {paymentStatus === 'failed' ? (
            <div className={classes.errorContainer}>
              <ErrorIcon className={classes.errorIcon} />
              <Typography variant="body1" className={classes.errorMessage}>
                {t('blikPaymentFailed')}
              </Typography>
            </div>
          ) : (
            <DialogContentText>
              {t('blikPaymentConfirmCode')}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={this.props.handleCloseDialog} color="primary">
            {t('ok')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(withTranslation()(ConfirmPaymentDialog));
